import { AHText, AHTextFonts, Box, ColorType } from "arkh";
import React, { PropsWithChildren } from "react";
import { Pressable } from "react-native";

export const ItemButtonTitle = (props: PropsWithChildren<object>) => {
  return (
    <AHText type="title-small" font={AHTextFonts.REGULAR} color="primary">
      {props.children}
    </AHText>
  );
};

export const ItemButton = (
  props: PropsWithChildren<{
    onPress(): void;
    borderColor?: ColorType;
    color?: ColorType;
    tabbable?: boolean;
  }>
) => {
  return (
    <Pressable
      hitSlop={{ top: 5, bottom: 20 }}
      onPress={props.onPress}
      style={({ pressed }) => ({ opacity: pressed ? 0.7 : 1 })}
      {...(props.tabbable
        ? {}
        : {
            tabIndex: -1,
          })}
    >
      <Box
        spaceVertical="xsmall"
        spaceHorizontal="medium"
        cornerRadius="large"
        color={props.color ?? "transparent"}
        style={{
          flexDirection: "row",
          alignItems: "center",
        }}
      >
        {props.children}
      </Box>
    </Pressable>
  );
};
